import React from 'react';

import {connect} from 'react-redux';
import {compose} from 'redux';
import './styles.scss';

interface ArrowIconProps {
  globalStyles: any;
  classNames?: string;
}

function ArrowIcon({globalStyles, classNames}: ArrowIconProps) {
  return (
    <svg
      width="12px"
      height="12px"
      viewBox="0 0 12 12"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames}>
      <defs>
        <filter id="filter-2">
          <feColorMatrix
            in="SourceGraphic"
            type="matrix"
            values="0 0 0 0 0.000000 0 0 0 0 0.694118 0 0 0 0 0.819608 0 0 0 1.000000 0"></feColorMatrix>
        </filter>
        <path
          d="M9.38233183,0.389032238 L5.86588546,4.28751765 L5.86588546,4.28751765 L2.30386036,0.338501673 C2.06702191,0.0759578954 1.70914779,-0.0420122584 1.36261378,0.0282434579 C1.12854298,0.0756985728 0.906611083,0.182954827 0.696818079,0.350012219 C0.477435054,0.524706109 0.307736409,0.735799917 0.187722143,0.983293644 C0.0122331521,1.34511625 0.0705765132,1.77685372 0.335784462,2.07913956 L4.83914277,7.21209825 L4.83914277,7.21209825 C5.36460128,7.87197638 6.36716964,7.87197638 6.89262815,7.21209825 L11.3618712,2.11802441 C11.6157155,1.82869979 11.6809728,1.41936522 11.5296807,1.06544942 C11.3881326,0.734327811 11.2257868,0.495848744 11.0426433,0.350012219 C10.8505244,0.19702868 10.5801053,0.101864455 10.2313861,0.0645195431 C9.91271642,0.0303691035 9.59699447,0.151047903 9.38233183,0.389032238 Z"
          id="path-3"></path>
      </defs>
      <g
        id="03-Rede-Medica_Desktop"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g id="MY-D-03-02-05" transform="translate(-293.000000, -484.000000)">
          <g
            id="03_Module/Rede-Medica/Search-Bar/myAdv"
            transform="translate(208.000000, 391.000000)">
            <path
              d="M32,0 L992,0 C1009.67311,-3.24649801e-15 1024,14.326888 1024,32 L1024,109 C1024,126.673112 1009.67311,141 992,141 L32,141 C14.326888,141 2.164332e-15,126.673112 0,109 L0,32 C-2.164332e-15,14.326888 14.326888,3.24649801e-15 32,0 Z"
              id="Rectangle"
              fill="url(#linearGradient-1)"></path>
            <g
              id="SiteAdvanceCare/01_Elements/Forms/Input-+-dropdown/Small"
              transform="translate(74.000000, 83.000000)">
              <g filter="url(#filter-2)" id="State">
                <g transform="translate(20.000000, 0.000000)"></g>
              </g>
              <g id="Icon" transform="translate(11.187500, 12.062500)">
                <mask id="mask-4" fill="white">
                  <use xlinkHref="#path-3"></use>
                </mask>
                <use
                  id="Color"
                  fill={globalStyles.primaryColor}
                  fillRule="nonzero"
                  xlinkHref="#path-3"></use>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

const mapStateToProps = ({globalStyles}: any) => ({
  globalStyles: globalStyles.value,
});

export default compose(connect(mapStateToProps)(ArrowIcon));
